export default {
  title: 'Comparte este recurso',
  link: 'Obtén el vínculo para tus estudiantes',
  preview: 'Vista Previa del Estudiante',
  back: 'Volver',
  searchPlaceholder: 'Nombre o correo electrónico',
  shareButton: 'Compartir',
  linkCopied: 'Link copiado al portapapeles',
  share: 'Compartir',
  doneModal: '¡Gracias!',
  requiredTeachers: 'Seleccione un profesor',
  selectAll: 'Seleccionar todos',
  search: 'Buscar',
  emptyLevelsOption: 'Todos los niveles',
  createGroup: 'Crear grupo',
  emptySchoolsSelect: 'Mostrar toda la red de escuelas',
  getLink: 'Obtener link',
  editGroup: 'Editar grupo',
  chooseShareType: 'Selecciona con quienes compartirás el contenido',
  students: 'Estudiantes',
  studentsDescription: 'Elige las clases que deseas compartir con tus estudiantes.',
  schoolGroup: 'Colegas',
  schoolGroupDescription: 'Elige los integrantes de la escuela con quienes deseas compartir el contenido.',
  selectClasses: '1. Seleccionar clases',
  selectPlatform: '2. Seleccionar plataforma',
  allClasses: 'Todo',
  platforms: {
    link: 'Enlace',
    classroom: 'Classroom'
  }
}

export const en = {
  title: 'Share this resource',
  link: 'Get link for your students',
  preview: 'Student\'s preview',
  back: 'Back',
  searchPlaceholder: 'Name or email',
  shareButton: 'Share',
  linkCopied: 'Link copied to clipboard',
  share: 'Share',
  doneModal: 'Thank you!',
  requiredTeachers: 'Select a teacher',
  selectAll: 'Select all',
  search: 'Search',
  emptyLevelsOption: 'All levels',
  createGroup: 'Create group',
  emptySchoolsSelect: 'Show all school network',
  getLink: 'Get link',
  editGroup: 'Edit group',
  chooseShareType: 'Select with whom you will share the content',
  students: 'Students',
  studentsDescription: 'Choose the classes you want to share with your students.',
  schoolGroup: 'Colleagues',
  schoolGroupDescription: 'Choose the school members with whom you want to share the content.',
  selectClasses: '1. Select classes',
  selectPlatform: '2. Select platform',
  allClasses: 'All',
  platforms: {
    link: 'Link',
    classroom: 'Classroom'
  }
}

export const ca = {
  title: 'Comparteix el recurs',
  link: 'Aconsegueix l\'enllaç per als teus estudiants',
  preview: 'Vista Prèvia de l\'Estudiant',
  back: 'Torna',
  searchPlaceholder: 'Nom o correu electrònic',
  shareButton: 'Comparteix',
  linkCopied: 'Enllaç copiat al porta-retalls',
  share: 'Comparteix',
  doneModal: 'Gràcies!',
  requiredTeachers: 'Selecciona un professor',
  selectAll: 'Seleccionar tots',
  search: 'Buscar',
  emptyLevelsOption: 'Tots els nivells',
  createGroup: 'Crear grup',
  emptySchoolsSelect: 'Mostrar tota la xarxa d\'escoles',
  getLink: 'Obtenir enllaç',
  editGroup: 'Editar grup',
  chooseShareType: 'Selecciona amb qui compartiràs el contingut',
  students: 'Estudiants',
  studentsDescription: 'Tria les classes que desitges compartir amb els teus estudiants.',
  schoolGroup: 'Col·legues',
  schoolGroupDescription: 'Tria els integrants de l\'escola amb els qui desitges compartir el contingut.',
  selectClasses: '1. Seleccionar classes',
  selectPlatform: '2. Seleccionar plataforma',
  allClasses: 'Tot',
  platforms: {
    link: 'Enllaç',
    classroom: 'Classroom'
  }
}
